import { useState, useCallback } from "react";
import { authenticatedFetch } from '@/services/auth/authenticatedFetch.js';

export default function useAITranslation() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [translations, setTranslations] = useState({
        translatedTextEN: "",
        translatedTextFR: "",
        translatedTextDE: "",
        translatedTextIT: "",
        translatedTextES: "",
        translatedTextNL: "",
    });

    const translate = useCallback(
        async (text, sourceLanguage) => {
            setLoading(true);
            setError(null);
            try {
                const API_URL = window.ENV.BACKEND_URL+"/api/secured/ai/translate";
                const response = await authenticatedFetch(API_URL, {
                    method: 'POST',
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ text, sourceLanguage }),
                }, { retryOnUnauthorized: true });
                if (!response.ok) {
                    throw new Error((await response.text()) || response.statusText || String(response.status));
                }
                const data = await response.json();
                setTranslations(data);
                return { data, error: null };
            } catch (err) {
                setError(err.message);
                return { data: null, error: err.message };
            } finally {
                setLoading(false);
            }
        },
        []
    );

    return { loading, error, translations, translate };
};

export function getSkillsType() {
    return ["SOFT", "HARD", "POWER"];
}
